import constants from './constants';

const authApi = {
    login: async (email, password) => {
        try {
            const response = await fetch(`${constants.AUTH_API_URL}/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({ email, password })
            });

            const data = await response.json();

            if (!response.ok) {
                // Create an error object with both status and message
                const error = new Error(data.message || 'Login failed');
                error.status = response.status;
                error.data = data; // Preserve the full error response
                throw error;
            }

            return data;
        } catch (error) {
            console.error('Login error:', error);
            throw error;
        }
    },

    logout: () => {
        localStorage.removeItem('user');
    },

    register: async (firstName, username, email, password) => {
        try {
            const response = await fetch(`${constants.AUTH_API_URL}/register`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json'
                },
                body: JSON.stringify({
                                         firstName,
                                         username,
                                         email,
                                         password
                                     })
            });

            const json = await response.json();

            return json;
        } catch (error) {
            return {
                success: false,
                message: error.message || 'Registration failed'
            };
        }
    },

    getCurrentUser: () => {
        try {
            const userStr = localStorage.getItem('user');
            if (!userStr) return null;

            return JSON.parse(userStr);
        } catch (error) {
            console.error('Get current user error:', error);
            localStorage.removeItem('user');
            return null;
        }
    },

    authHeader: () => {
        const user = authApi.getCurrentUser();

        if (user?.token) {
            return { Authorization: `Bearer ${user.token}` };
        }
        return {};
    }
};

export default authApi;
